import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UnauthorizePromptService {
  /** store for popup state */
  private isPopupShown = new BehaviorSubject<boolean>(false);
  /** public isPopup state. */
  public readonly isPopupShown$ = this.isPopupShown.asObservable();

  public popupTitle = 'Unauthorized action';
  public popupMessage = `
    <p data-test-id="popup-unauthorized-p1" class="mb-0">You have been logged out from SYNLAB Access.</p>
    <p data-test-id="popup-unauthorized-p2" class="mb-0">Click <strong data-test-id="popup-unauthorized-continue" >continue</strong> to log in again.</p>
  `;
  public popupTitleDefault = 'Unauthorized action';
  public popupMessageDefault = `
    <p data-test-id="popup-unauthorized-p1" class="mb-0">You have been logged out from SYNLAB Access.</p>
    <p data-test-id="popup-unauthorized-p2" class="mb-0">Click <strong data-test-id="popup-unauthorized-continue" >continue</strong> to log in again.</p>
  `;

  constructor(private actRoute: ActivatedRoute) {}

  /** shows popup. pass `false` to hide. */
  showPopup(isShown: boolean = true) {
    this.isPopupShown.next(isShown);
  }
  get routeData() {
    return this.actRoute.snapshot.data;
  }
}
